/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Principal } from '../models/Principal';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class IdentityService {
    /**
     * Authenticated principal
     * Returns the identity of the authenticated caller derived from the Entra ID JWT.
     * @returns Principal Authenticated principal.
     * @throws ApiError
     */
    public static getMe(): CancelablePromise<Principal> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/me',
            errors: {
                401: `Missing or invalid bearer token.`,
            },
        });
    }
}
